// extracted by mini-css-extract-plugin
var _1 = "ColumnsControls_columnControl__2cb53";
var _2 = "ColumnsControls_container__009aa";
var _3 = "ColumnsControls_title__090c8";
export { _1 as "columnControl", _2 as "container", _3 as "title" }
